import { api_url } from "../../../utils";

const RepartoModal = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=reparto_modal&schema_city=",
    zindex: 3,
    type: "pie",
    pieProps: {
        data: ["nb_ti", "nb_tc", "nb_taxi", "nb_caminat", "nb_bici"],
        total: "nb_total",
        colors: [
            "rgb(179, 51, 158)",
            "rgb(50, 143, 182)",
            "rgb(210, 185, 59)",
            "rgb(133, 189, 122)",
            "rgb(26, 58, 21)",
        ],
    },
    popup: {
        default: {
            content: {
                es: {
                    nombre: "Nombre de la macrozona: ",
                    nb_total: "Total de viajes: ",
                    nb_ti: "Viajes en Transporte Individual (auto, moto): ",
                    nb_tc: "Viajes en Transporte Colectivo: ",
                    nb_taxi: "Viajes en Taxi (Taxi y Moto-Taxi): ",
                    nb_caminat: "Viajes en caminata: ",
                    nb_bici: "Viajes en Bicicleta: ",
                },
            },
            separators: {
                decimal: [],
                thousand: [
                    "nb_total",
                    "nb_ti",
                    "nb_tc",
                    "nb_taxi",
                    "nb_caminat",
                    "nb_bici",
                ],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.RepartoModal",
    style: {
        regular: false,
        fillColor: "rgb(35, 35, 35)",
        strokeColor: "rgb(35, 35, 35)",
        strokeWidth: 1,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.RepartoModal.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass: "",
            class: [
                {
                    fillColor: "rgb(179, 51, 158)",
                    strokeColor: "rgb(179, 51, 158)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.RepartoModal.classes.1",
                },
                {
                    fillColor: "rgb(50, 143, 182)",
                    strokeColor: "rgb(50, 143, 182)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.RepartoModal.classes.2",
                },
                {
                    fillColor: "rgb(210, 185, 59)",
                    strokeColor: "rgb(210, 185, 59)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.RepartoModal.classes.3",
                },
                {
                    fillColor: "rgb(133, 189, 122)",
                    strokeColor: "rgb(133, 189, 122)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.RepartoModal.classes.4",
                },
                {
                    fillColor: "rgb(26, 58, 21)",
                    strokeColor: "rgb(26, 58, 21)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.RepartoModal.classes.5",
                },
            ],
        },
    },
};

export default RepartoModal;
